import InnerInput from "components/inputs/InnerInput/InnerInput";
import styles from "../../email/NotificationEmailEditModal.module.scss";
import DefaultDropdown from "components/dropdowns/DefaultDropdown/DefaultDropdown";
import { t } from "i18next";
import SwitchBtn from "components/buttons/SwitchBtn";
import { UploadImageWithPreview } from "modals/notifications/email/FileUploadWithPreview";
import {
  EmailTemplateItem,
  UpdateEmailTemplateItemPayload,
} from "store/emails/slice";
import TextEditor from "components/wysiwyg/Wysiwyg";

type Props = {
  payload: (Omit<EmailTemplateItem, "id"> & { id?: number }) | undefined;
  handleUpdateField: (
    key: keyof UpdateEmailTemplateItemPayload,
    value: UpdateEmailTemplateItemPayload[keyof UpdateEmailTemplateItemPayload]
  ) => void;
  imageHeader: any;
  types: string[];
  readOnly?: boolean;
};

export const EmailMainTab: React.FC<Props> = ({
  payload,
  handleUpdateField,
  imageHeader,
  types,
  readOnly
}) => {
  return (
    <>
      <div className={styles["email-header"]}>
        <div className={styles["email-media"]}>
          <InnerInput
            value={payload?.title?.toString() ?? ""}
            placeholder={t("title")}
            label={t("title")}
            type="text"
            id="email-title"
            onChange={(e) => handleUpdateField("title", e)}
            disabled={readOnly}
          />
          <div className={styles["email-upload-button"]}>
            <UploadImageWithPreview
              image={payload?.headerImageRef}
              ref={imageHeader}
              disabled={readOnly}
            />
          </div>
        </div>
        <div className={styles["email-settings"]}>
          <div className={styles["email-settings-row"]}>
            <InnerInput
              value={payload?.key?.toString() ?? ""}
              placeholder={t("Key")}
              label={t("Key")}
              tooltipText={t("notificationKeyTooltip")}
              tooltipPosition="top-left"
              type="text"
              id="email-key"
              onChange={(e) => handleUpdateField("key", e)}
              disabled={readOnly}
            />
            <div className={styles["email-type"]}>
              <DefaultDropdown
                value={payload?.type}
                onSelect={(e) => {
                  handleUpdateField("type", e as any);
                }}
                placeholder={t("type")}
                label={t("type")}
                isBot
                options={types.map((type) => ({ value: type, label: t(type) }))}
                disabled={readOnly}
              />
            </div>
          </div>
          <SwitchBtn
            activeTxt={t("active")}
            isActive={!!payload?.isActive}
            handleClick={() =>
              handleUpdateField("isActive", !!payload?.isActive ? 0 : 1)
            }
            disabled={readOnly}
          />
        </div>
      </div>
      <div className={`html-editor ${styles["email-editor"]}`}>
        <TextEditor
          value={payload?.content ?? ""}
          onChange={(html) => handleUpdateField("content", html)}
          disabled={readOnly}
        />
      </div>
    </>
  );
};
